import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { AuthService } from '../../shared/service/auth.service';

@Component({
  selector: 'app-sign-in',
  templateUrl: './sign-in.component.html',
  styleUrls: ['./sign-in.component.scss'],
})
export class SignInComponent implements OnInit {
  loginForm!: FormGroup;
  private loginFormSubmitAttempt!: boolean;

  constructor(private fb: FormBuilder, private authService: AuthService) {}

  ngOnInit() {
    //initialize form with required fields
    this.loginForm = this.fb.group({
      emailAddress: ['', Validators.required],
      password: ['', Validators.required],
    });
  }

  SignInGoogleAuth() {
    this.authService.SignInGoogleAuth();
  }
  
  isFieldInvalid(field: string) {
    return (
      (!this.loginForm.get(field)?.valid &&
        this.loginForm.get(field)?.touched) ||
      (this.loginForm.get(field)?.untouched && this.loginFormSubmitAttempt)
    );
  }

  onSubmit() {
    if (this.loginForm.valid) {
      this.authService.SignIn(
        this.loginForm.value.emailAddress,
        this.loginForm.value.password
      );
    }
    this.loginFormSubmitAttempt = true;
  }
}
